import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { UserProvider } from '../src/Componentes/UserContext';
import Home from './Componentes/Home/index';
import Menu from './Componentes/Menu/index';
import Almoxarifado from './Componentes/Almoxarifado/Index';
import Producao from './Componentes/Producao/index';
import Estoque from './Componentes/Estoque/index';
import Footer from './Componentes/Footer/index'; // Importação do Footer
import Solicitacoes from './Componentes/Solicitacoes';
import Relatorio from './Componentes/Relatorio/Index.jsx';

const App = () => {
  return (
    <UserProvider>
      <Router>
        <div>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/home" element={<Home />} />
            <Route path="/menu" element={<Menu />} />
            <Route path="/almoxarifado" element={<Almoxarifado />} />
            <Route path="/producao" element={<Producao />} />
            <Route path="/estoque" element={<Estoque />} />
            <Route path="/solicitacoes" element={<Solicitacoes />} />
            <Route path="/relatorio" element={<Relatorio />} /> 
          </Routes>
          {/* Rodapé global */}
          <Footer />
        </div>
      </Router>
    </UserProvider>
  );
};

export default App;

